import { TaskPreview } from 'api/notifications';

export type TimeEntryBase = {
  notes?: string;
  minutes: number;
  billable: boolean;
  categoryId?: number;
  date: string;
};

export type TaskTimeEntry = TimeEntryBase & {
  type: 'TASK_ENTRY';
  task: TaskPreview;
  userId: number;
  date: string;
};

export enum TimesheetSourcePage {
  Approvals = 'APPROVALS',
  MyTimesheet = 'MY_TIME_SHEET',
}
